import { Slider } from "@/components/ui/slider";
import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { CustomFormItemProps } from "../accelerators-form";
import { Input } from "@/components/ui/input";

export function CommissionSelector({ value, onChange }: CustomFormItemProps) {
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    onChange(inputValue);
  };

  return (
    <FormItem>
      <div className="grid gap-2 pt-2">
        <div className="grid gap-4">
          <div className="flex items-center justify-between">
            <FormLabel className="text-xl" htmlFor="rate">
              <div className="flex flex-row items-center gap-x-1">
                <Input
                  id="rate"
                  value={value}
                  onChange={handleInput}
                  className="px-2 h-8 w-[72px] text-right"
                />
                % commission
              </div>
            </FormLabel>
          </div>
          <FormControl>
            <Slider
              max={250}
              value={[value.toString()]}
              step={1}
              onValueChange={(vals) => {
                onChange(vals[0].toString());
              }}
              className="[&_[role=slider]]:h-4 [&_[role=slider]]:w-4"
              aria-label="Rate"
            />
          </FormControl>
        </div>
      </div>
      <FormMessage />
    </FormItem>
  );
}
